import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Star Wars Vehicles N People';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts